import { serviceConfigs } from './configs';
import * as localStorageService from './local-storage-service';
import * as httpService from './http-service';
import React, { forwardRef } from 'react';
import Slide from '@material-ui/core/Slide';

// تابع تشخیص خطاهای قابل تلاش مجدد
function isRetryableError(error) {
	// اگر خطا network error باشه (مثل عدم اتصال اینترنت)
	if (!error.response) {
		return true;
	}

	const status = error.response.status;

	// خطاهای موقتی سرور که قابل تلاش مجدد هستند
	const retryableStatusCodes = [
		502, // Bad Gateway
		503, // Service Unavailable
		504, // Gateway Timeout
		520, // Cloudflare Unknown Error
		521, // Cloudflare Web Server Is Down
		522, // Cloudflare Connection Timed Out
		523, // Cloudflare Origin Is Unreachable
		524, // Cloudflare A Timeout Occurred
		525, // Cloudflare SSL Handshake Failed
		526, // Cloudflare Invalid SSL Certificate
		527, // Cloudflare Railgun Error
		429  // Too Many Requests (Rate Limiting)
	];

	return retryableStatusCodes.includes(status);
}

async function withRetry(fn, retries = 1, delay = 2000) {
	try {
		return await fn();
	} catch (err) {
		// اگر خطا قابل تلاش مجدد نیست، فوری throw کن
		if (!isRetryableError(err)) {
			throw err;
		}

		// اگر تعداد تلاش‌های باقی‌مانده تمام شده، خطا رو throw کن
		if (retries <= 0) {
			throw err;
		}

		// صبر کن و دوباره تلاش کن
		await new Promise((res) => setTimeout(res, delay));
		return withRetry(fn, retries - 1, delay);
	}
}

export function makeGetRequest(url, haveToken = true, retries = 1) {
	return withRetry(() => httpService.GET(url, haveToken), retries);
}

export function makePostRequest(url, params, haveToken = true, retries = 1) {
	return withRetry(() => httpService.POST(url, params, haveToken), retries);
}

export function makePutRequest(url, params, haveToken = true, retries = 1) {
	return withRetry(() => httpService.PUT(url, params, haveToken), retries);
}

export function makeDeleteRequest(url, haveToken = true, retries = 1) {
	return withRetry(() => httpService.DELETE(url, haveToken), retries);
}

export function makeFinalRequest(url, params = {}, version = 0) {
	return serviceConfigs[version].base_url + serviceConfigs[version].version + url + makeQueryStringFromDictionary(params);
}

export function makeQueryStringFromDictionary(params = {}) {
	let output = '';
	if (params && typeof params !== 'undefined') {
		output += '?';
		for (const key of Object.keys(params)) {
			output += key + '=' + params[key] + '&';
		}
	}
	return output.slice(0, -1);
}

export function setTitle(title) {
	document.title = title;
}

export function persianNumberToLatin(number) {
	const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
	const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
	if (typeof number === 'string') {
		for (let i = 0; i < 10; i++) {
			number = number.replace(persianNumbers[i], String(i)).replace(arabicNumbers[i], String(i));
		}
	}
	return number;
}

export function latinNumberToPersian(number) {
	const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
	const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
	if (typeof number === 'string') {
		for (let i = 0; i < 10; i++) {
			number = number.replace(String(i), persianNumbers[i]).replace(String(i), arabicNumbers[i]);
		}
	}
	return number;
}

export function isPlatformBrowser() {
	return typeof window !== 'undefined';
}

export function setLocalStorage(key, data, is_pure = false) {
	localStorageService.SET(key, data, is_pure);
}

export function getLocalStorage(key, is_pure = false) {
	return localStorageService.GET(key, is_pure);
}

export function removeLocalStorage(key) {
	localStorageService.REMOVE(key);
}

export function updateLocalStorage(key, value, is_pure = false) {
	localStorageService.UPDATE(key, value, is_pure);
}

export function clearLocalStorage() {
	localStorageService.CLEAR();
}

export const ModalTransition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export const handleTimeStamp = (value, type = '') => {
	const persianDate = new Date(value).toLocaleString('fa-ir').toString();
	const time = persianDate.split(/[،,]/)[1].split(':')[0] + ':' + persianDate.split(/[،,]/)[1].split(':')[1];
	let date = persianDate.split(/[،,]/)[0].replaceAll('/', ' / ');
	date = date.split('/')[2] + '/' + date.split('/')[1] + '/' + date.split('/')[0];
	if (type === 'onlyTime') {
		return time;
	} else if (type === 'onlyDate') {
		return date;
	} else {
		return time + ' - ' + date;
	}
};